import { apiEmpleo } from "../../util/ApiEmpleo";

export const PREFILTER_CANDIDATE_MAX_RESULTS = "PREFILTER_CANDIDATE_MAX_RESULTS";

export type TSetting = {
  key: string;
  value: string;
};

const apiGetSetting = async (key: string): Promise<TSetting> => {
  const res: TSetting = await apiEmpleo.get(`settings/${key}`);

  return res;
};

export { apiGetSetting };
